<template>
  <button
    class="klienticta client-action-button"
    :class="classCst"
    type="button"
    aria-label="Otvoriť hypotéky klienta"
    title="Otvoriť hypotéky"
    @click="openMortgagePicker"
  >
    <span class="client-action-icon"><app-icon name="briefcase" :size="22" /></span>
    <span>Hypotéky</span>
  </button>
</template>

<script>
import AppIcon from "@/components/shared/AppIcon.vue";

export default {
  name: "MortgagePickerHandler",
  components: {AppIcon},
  props: {
    rules: [Array, null],
    client: Object,
    classCst: [String, null],
  },
  methods: {
    openMortgagePicker () {
      this.$store.commit("popupManagerState/pushToPopupOrder", {
        type: null,
        payload: {mortgages: this.client.mortgages, id: this.client.id, title: 'EDIT'},
        component: "MortgagePickerPopUp",
        rules: this.rules,
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.client-action-button {
  min-width: 62px;
  min-height: 58px;
  padding: 5px 8px;
  border: 1px solid transparent;
  border-radius: 12px;
  outline: none;
  background: transparent;
  color: var(--app-primary);
  cursor: pointer;
  font: inherit;
  line-height: 1.15;
  transition: border-color .18s ease, background .18s ease, transform .18s ease;
}

.client-action-icon {
  display: grid;
  width: 34px;
  height: 34px;
  margin-bottom: 3px;
  place-items: center;
  border: 1px solid var(--app-border);
  border-radius: 10px;
  background: var(--app-surface-muted);
}

.client-action-button:hover,
.client-action-button:focus-visible {
  border-color: var(--app-primary);
  background: rgba(98, 180, 255, .08);
  transform: translateY(-1px);
}

</style>
